module.exports = __webpack_public_path__ + "img/shikoku_mas.4bd23fa4.png";